import { render, staticRenderFns } from "./TelegramForm.vue?vue&type=template&id=454d2e13"
import script from "./TelegramForm.vue?vue&type=script&lang=js"
export * from "./TelegramForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports